export default async () => {
  const filterXSSOverride = require('filterXSSOverride');
  filterXSSOverride();
};
